import axiosClient from 'api/config/axiosClient';
import { isNull } from 'lodash';

export const getAccountAccessRanking = ({
  pageNumber,
  pageSize,
  dateFrom,
  dateTo,
  keyword,
}) => {
  const url = `v1/logging/ranking/page-access/by-email?pageNumber=${pageNumber}&pageSize=${pageSize}&dateFrom=${dateFrom}&dateTo=${dateTo}&keyword=${isNull(keyword) ? '' : keyword}`;
  return axiosClient.get(url, { timeout: 0 });
};

export const getAccountFileDownloadRanking = ({
  pageNumber,
  pageSize,
  dateFrom,
  dateTo,
  keyword,
}) => {
  const url = `v1/logging/ranking/file-download/by-email?pageNumber=${pageNumber}&pageSize=${pageSize}&dateFrom=${dateFrom}&dateTo=${dateTo}&keyword=${isNull(keyword) ? '' : keyword}`;
  return axiosClient.get(url, { timeout: 0 });
};

export const getEmails = () => {
  const url = `v1/account/emails`;
  return axiosClient.get(url);
};
